import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667l0 -8.666","key":"svg-0"}],["path",{"d":"M4.012 16.737a2 2 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1","key":"svg-1"}],["path",{"d":"M11.5 11.5l4.9 5","key":"svg-2"}],["path",{"d":"M16.5 11.5l-5.1 5","key":"svg-3"}]]

const IconCopyX = createReactComponent('outline', 'copy-x', 'CopyX', __iconNode);

export default IconCopyX;